import Jumbotron from "../../../components/Jumbotron.component";
import TableTaskListSPV from "../../../components/TableTaskList.component";
import SEO from "../../SEO";

const TaskList = () => {
  return (
    <>
      <SEO title="Supervisor" description="Project From Worker" content="Project From Worker"  />

     <Jumbotron
        notPlanner={true}
        description={
          "This menu is representative all projects that are came from worker. You may done, return to worker and complete projects that are submitted by worker"
        }
      />
      <TableTaskListSPV />
    </>
  );
};

export default TaskList;
